import { useState } from "react";
import { useSnackbar } from "notistack";
import { CreateRoute } from "./Context";
import { useContext, useEffect } from "react";

export const  validateToken  = async ({userData}) => {

    
    const  current = Date.now();
    const hours_1 = 1 * 60 * 60 * 1000;
    const isTimeToRefresh = (current - userData.tokenFixedTime > hours_1);


    if (isTimeToRefresh || !userData.tokenFixedTime) {
        try {
            const fetchtoken = await fetch(`${process.env.REACT_APP_API_URL}/regulartokenrefresh`, {
            "method": "POST",
            "credentials": "include"
            })
            const fetchTokenJson = await fetchtoken.json()
            const token = fetchTokenJson._accToken
            return token; 
        }
        catch (error) {
            console.error(error);
            return;
        }
        
    }
   
    else {
        return Promise.resolve(userData.userToken)
    }
    
   
    
    
};



export const loadFonts = () => {
    const fontUrl = `${process.env.REACT_APP_API_URL}/font_rules_css`;
    if (fontUrl) {
      const linkElement = document.createElement('link');
      linkElement.rel = 'stylesheet';
      linkElement.href = fontUrl;
      document.head.appendChild(linkElement);
    }
  };
    


export function useNotify() {

    const {enqueueSnackbar} = useSnackbar()
        function notify(
            {
                message="",
                variant="",
                duration=3000,
                vertical="top",
                horizontal= "center",
                action=null,
                persist=false
            }={}
        ) { enqueueSnackbar(
                message, {
                    anchorOrigin:{
                        vertical: vertical,
                        horizontal: horizontal
                    },
                    persist,
                    action,
                    "autoHideDuration": duration,
                    "variant": variant
                })
            }               
            return notify;                                                                                                                                                                      

}


export function useRoute() {
    const [,setParams] = useContext(CreateRoute)
    const [newParams, setNewParams] = useState({})

    useEffect(() => {
        setParams(newParams);
    },[newParams])

    return (path,Component,params) => {
        setNewParams({
            path: path,
            element: Component,
            params: params

    });
}

}


